import {createRouter, createWebHistory} from "vue-router";

const routes = [
    {
        path: "/",
        redirect: "/home",
    }, {
        path: "/home",
        name: "home",
        component: () => import("@/pages/Home.vue"),
    }, {
        path: "/login",
        name: "login",
        component: () => import("@/pages/Login.vue"),
    }, {
        path: "/newsdetail",
        name: "newsdetail",
        component: () => import("@/pages/NewsDetail.vue"),
    }, {
        path: "/college",
        name: "college",
        component: () => import("@/pages/College.vue"),
    }, {
        path: "/collegedetail",
        name: "collegedetail",
        component: () => import("@/pages/CollegeDetail.vue"),
    }, {
        path: "/expertlist",
        name: "expertlist",
        component: () => import("@/pages/ExpertList.vue"),
    }, {
        path: "/majorlib",
        name: "majorlib",
        component: () => import("@/pages/MajorLib.vue"),
    }, {
        path: "/speclib",
        name: "speclib",
        component: () => import("@/pages/SpecLib.vue"),
    }, {
        path: "/postlib",
        name: "postlib",
        component: () => import("@/pages/PostLib.vue"),
    }, {
        path: "/planlib",
        name: "planlib",
        component: () => import("@/pages/PlanLib.vue"),
    }, {
        path: "/placequery",
        name: "placequery",
        component: () => import("@/pages/PlaceQuery.vue"),
    }, {
        path: "/scorequery",
        name: "scorequery",
        component: () => import("@/pages/ScoreQuery.vue"),
    }, {
        path: "/volunteer",
        name: "volunteer",
        component: () => import("@/pages/Volunteer.vue"),
    }, {
        path: "/myreport",
        name: "myreport",
        component: () => import("@/pages/MyReport.vue"),
    }, {
        path: "/evaluation",
        name: "evaluation",
        component: () => import("@/pages/Evaluation.vue"),
    }, {
        path: "/evalresult",
        name: "evalresult",
        component: () => import("@/pages/EvalResult.vue"),
    }, {
        path: "/about",
        name: "about",
        component: () => import("@/pages/About.vue"),
    }, {
        path: "/services",
        name: "services",
        component: () => import("@/pages/Services.vue"),
    }, {
        path: "/contact",
        name: "contact",
        component: () => import("@/pages/Contact.vue"),
    },
];

//createWebHashHistory()
const router = createRouter({
    history: createWebHistory(),
    routes: routes,
});

//前置路由守卫
router.beforeEach((to, from, next) => {
    if (to.path == "/login") {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        if (userInfo?.phone) {
            next("/home");
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
